import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Spinner, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CampaignTypeService } from '../../../../../Services/Axios/Api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AddCampaignType = () => {
    const [title, setTitle] = useState('');
    const [mode, setMode] = useState('Normal');
    const [isGeneralDonation, setIsGeneralDonation] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [showSuccess, setShowSuccess] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        if (!title.trim()) {
            newErrors.title = 'Title is required';
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formErrors = validateForm();
        if (Object.keys(formErrors).length === 0) {
            setLoading(true);
            setErrors({});
            console.log('Title:', title);
            console.log('Mode:', mode);
            const response = await CampaignTypeService.createCampaignType({
                name: title,
                mode: mode,
                isGeneralDonation: isGeneralDonation
            });
            setLoading(false);
            setShowSuccess(true);
            toast.success('Campaign type added successfully');
            setTimeout(() => {
                navigate(`/bj-admin/donations/campaignstype/edit/${response.result.id}`);
            }, 2000);
        } else {
            setErrors(formErrors);
        }
    };
    const navigate = useNavigate();
    const handleBack = () => {
        window.history.back();
    };

    return (
        <Container className="mt-5">
            <h2 className="mb-4">New Campaign Type</h2>
            {showSuccess && <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                Campaign type added successfully!
            </Alert>}
            <Form onSubmit={handleSubmit} noValidate>
                <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="formTitle">
                            <Form.Label>Title</Form.Label>
                            <Form.Control 
                                type="text" 
                                placeholder="Enter campaign title" 
                                value={title} 
                                onChange={(e) => setTitle(e.target.value)} 
                                isInvalid={!!errors.title}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.title}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="formMode">
                            <Form.Label>Mode</Form.Label>
                            <Form.Select
                                as="select" 
                                value={mode} 
                                onChange={(e) => setMode(e.target.value)}
                            >
                                <option value="Normal">Normal</option>
                                <option value="Progressing">Progressing</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="formIsGeneralDonation">
                            <Form.Check 
                                type="checkbox"
                                label="Is General Donation?"
                                checked={isGeneralDonation}
                                onChange={(e) => setIsGeneralDonation(e.target.checked)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <div className="d-flex justify-content-end">
                    <Button variant="success" className='me-2' type="submit" disabled={loading}>
                        {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Submit'}
                    </Button>
                    <Button variant="danger" onClick={handleBack}>Cancel</Button>
                </div>
            </Form>
        </Container>
    );
};

export default AddCampaignType;
